import {
  mockNotifications,
  mockStats,
  mockTodo
} from './notifications';
import mockActivity from './activity';
import mockFeed from './feed';

import { mockChart } from './chart';
import mockDashboard from './dashboard';

export {
  mockNotifications,
  mockStats,
  mockTodo,
  mockActivity,
  mockFeed,
  mockChart,
  mockDashboard
}


// WEBPACK FOOTER //
// ./src/utils/mock/index.js